// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class Survey {
    static getAttributeTypeMap() {
        return Survey.attributeTypeMap;
    }
}
Survey.discriminator = undefined;
Survey.attributeTypeMap = [
    {
        "name": "key",
        "baseName": "key",
        "type": "string"
    },
    {
        "name": "questions",
        "baseName": "questions",
        "type": "Array<SurveyQuestion>"
    }
];
//# sourceMappingURL=survey.js.map